var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"rule_btn",on:{"click":_vm.toRule}},[_c('div',{staticClass:"icon"},[_c('img',{attrs:{"src":_vm.data && _vm.data.buttonImage ? _vm.data.buttonImage : _vm.imageObj.rule_btn}})])])}
var staticRenderFns = []

export { render, staticRenderFns }